import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { Layout } from 'pages/AppManagement/containers';
import { PrivateRoute } from './PrivateRoutes';
import { pageRoutes } from './config';
import { PublicRoute } from './PublicRoute';

export const Routes = ({ ...props }: any) => {
  return (
    <Switch>
      {pageRoutes.public.map((route, ind) => (
        <PublicRoute exact {...route} {...props} key={ind} />
      ))}
      <Route path="/">
        <Layout
          isMenuOpen={props.layoutProps.isMenuOpen}
          locale={props.layoutProps.currentLocale}
          mode={props.layoutProps.mode}
        >
          <Switch>
            {pageRoutes.private.map((route, ind) => (
              <PrivateRoute exact {...route} {...props} key={ind} />
            ))}
          </Switch>
        </Layout>
      </Route>
      {/* <Redirect from="/" to="/call-to-action" /> */}
    </Switch>
  );
};
